/** @format */
import { ModelSearchResultsType } from '@toucan/common/services/search/constants';

import { useSearchParams } from '@toucan/client/features/search/components/model-search-results/hooks/use-search-params';
import { SortByOption } from '@toucan/client/features/search/config/types';
import { transformSortByToSortByOption } from '@toucan/client/features/search/helpers';

import { useSortByOptions } from '../use-sort-by-options';

export function useSortByOption(
    type?: ModelSearchResultsType,
    getDefaultSortOption?: (options: SortByOption[]) => SortByOption | undefined
): SortByOption {
    const { sort, outOfStock } = useSearchParams();

    const { categorySortByOptions, defaultSortByOption } = useSortByOptions(
        outOfStock,
        type
    );

    const defaultSortOption = (getDefaultSortOption
        ? getDefaultSortOption(categorySortByOptions)
        : defaultSortByOption) as unknown as SortByOption;

    if (!Object.keys(sort).length) {
        return defaultSortOption;
    }

    return transformSortByToSortByOption({
        sort,
        sortOptions: categorySortByOptions,
        defaultSortOption,
    });
}
